export default __webpack_public_path__ + "static/media/superball-b1.f8089056.png";